import { configureStore } from '@reduxjs/toolkit';

import authSlice from './authSlice';
import portalModalDialogSlice from './portalModalDialogSlice';
import uiSlice from './uiSlice';

const store = configureStore({
  reducer: {
    auth: authSlice,
    ui: uiSlice,
    portalModalDialogs: portalModalDialogSlice
  }
});

export default store;
